import Vue from '@/setup'

import { STORAGE_KEY } from '@/config/constants'
import { ApplicationHelper, LogHelper, RouteHelper, SessionHelper } from '@/helpers'
import { EVENT_BUSY, EVENT_CLOSE_ALL_MODALS, EVENT_READY, EVENT_SYNC_EXECUTED } from '@/config/events'

const { $EventBus, $session } = Vue.prototype

function $_syncNewSession(event) {
  if (!event.newValue || event.oldValue) return

  LogHelper.info('SYNCHRONIZE NEW SESSION')
  const location = window.location.href.replace(/(\/?#).*/, ``)
  window.open(location, '_self')
}

function $_needSync(event) {
  const oldValue = JSON.parse(event.oldValue)
  const newValue = JSON.parse(event.newValue)
  return oldValue?.updateDate !== newValue?.updateDate
}

function $_doSync(router) {
  $EventBus.$emit(EVENT_BUSY)

  return SessionHelper.resume()
    .then(basket => {
      if (router && !router.currentRoute?.meta?.aide) {
        const nextRoute = RouteHelper.getNextRoute(basket)
        let location = {
          name: nextRoute,
          query: {
            t: Date.now(),
          },
        }
        if (RouteHelper.invalidPersonIdParam(router.currentRoute, basket.persons)) {
          location.params = { personId: basket.persons[0]?.personId }
        }
        return router.replace(location).catch(_err => {})
      } else {
        // emit event to close all modals in widgets
        // e.g. pricewidget => close person modal
        $EventBus.$emit(EVENT_CLOSE_ALL_MODALS)
      }
    })
    .catch(e => {
      $session
        .get()
        .then(() => {
          // other errors already emitted by error interceptor
          if (!e.infoMessages) {
            ApplicationHelper.emitMessages([{ errorCode: 'NETWORK', errorLevel: 'ERROR' }])
          }
        })
        .catch(() => {
          LogHelper.info(["%cSync NO BASKET FOUND, BUT THAT'S OK :)", 'color: yellow'])
        })
    })
    .finally(() => {
      $EventBus.$emit(EVENT_READY)
      $EventBus.$emit(EVENT_SYNC_EXECUTED)
    })
}

function $_handleStorageEvent(router, event) {
  if (event.key !== STORAGE_KEY) return

  if (event.newValue === null) {
    const location = window.location.href.replace(/(\/?#).*/, ``)
    window.open(location, '_self')
    return
  }

  if (!$session.isActive()) {
    return $_syncNewSession(event)
  }

  try {
    if ($_needSync(event)) {
      $_doSync(router)
    }
  } catch (e) {
    LogHelper.error(['Failed to sync session after local storage update\n', e, event.oldValue, event.newValue])
    return e
  }
}

export const SyncHelper = {
  storageHandler: null,

  register(router) {
    if (SyncHelper.storageHandler) {
      throw new Error('SYNC Can not register another sync listener')
    }

    LogHelper.info('REGISTER SYNC')

    SyncHelper.storageHandler = $_handleStorageEvent.bind(this, router)
    window.addEventListener('storage', SyncHelper.storageHandler)
  },

  unregister() {
    LogHelper.info('UNREGISTER SYNC')
    window.removeEventListener('storage', SyncHelper.storageHandler)
  },
}
